import _ from "lodash";
import React, { useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { Icon } from "rsuite";
import { TranslationContext } from "../../umbilical_tools";
import { useHistory } from "react-router-dom";
import { sendPixelEvent } from "../../helpers";
import { Button } from "./Button";
import jssVariables from "../../jss_setup";
import { GlobalModalsContext } from "../../context";
import { usePropertyLangTag } from "../../hooks";
import { useSelector } from "react-redux";

const styles = createUseStyles({
  FailedBooking: (props) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    background: "white",
    padding: "0 10vw",
    ..._.get(props, "customStyles.BookingProcess", {}),
  }),
  booking: {
    textAlign: "center",
    display: "grid",
    alignContent: "center",
    height: "100%",
    gridGap: `calc(${jssVariables.normal_gap} * 2)`,
    gridAutoRows: "max-content",
  },
  icon: { color: "red" },
  col2: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridGap: jssVariables.normal_gap,
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    FailedBooking: (props) => ({
      padding: "0 40vw",
    }),
  },
});
const FailedBooking = () => {
  const classes = styles();
  const { t } = useContext(TranslationContext);
  const { setShowContactUsModal } = useContext(GlobalModalsContext);
  const history = useHistory();

  const langTag = usePropertyLangTag();
  const failMsg = useSelector((state) => {
    var msg =
      state?.WebsiteMetadata?.metadata?.[`booking_failure_msg${langTag}`];
    if (!msg) {
      msg = state?.WebsiteMetadata?.metadata?.booking_failure_msg;
    }
    return msg;
  });

  useEffect(() => {
    sendPixelEvent("failedBooking");
  }, []);

  return (
    <div className={classes.FailedBooking}>
      <div className={classes.booking}>
        <Icon className={classes.icon} icon="exclamation-circle" size="5x" />
        <h4>{t("bookingFailed")}!</h4>
        <h5>{failMsg}</h5>
        <div className={classes.col2}>
          <Button text={t("backToHome")} onClick={() => history.push("/")} />
          <Button
            text={t("contactUs")}
            onClick={() => setShowContactUsModal(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default FailedBooking;
